import React from "react";
import { FormattedMessage } from "react-intl";
import { Box, Text } from "@chakra-ui/react";
import styled from "@emotion/styled";

const HoverBox = styled(Box)`
  &:hover {
    * {
      display: block;
    }
  }
`;

export const FormatLabel = props => {
    const showLabels = window.location.search.includes("showLabels");
    if (showLabels){
        return (
            <HoverBox>
                {/*eslint-disable-next-line react/prop-types*/}
                <Text display="none">{props.id}</Text>
                <FormattedMessage {...props} />
            </HoverBox>
        );
    }
    return <FormattedMessage {...props} />;
};
